export const ItemView = () => {
  return (
    <svg
      width="255px"
      height="252px"
      viewBox="0 0 255 252"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>icons/overview</title>
      <defs>
        <polygon
          id="path-1-ItemView"
          points="0 250.758355 254.744975 250.758355 254.744975 0 0 0"
        ></polygon>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="icons/overview" transform="translate(0.126070, 0.342011)">
          <path
            d="M13.95331,105.247035 L105.246892,105.247035 L105.246892,13.9534524 L13.95331,13.9534524 L13.95331,105.247035 Z M106.642209,119.200202 L12.5579932,119.200202 C5.51591497,119.200202 0.000142379261,113.683718 0.000142379261,106.642352 L0.000142379261,12.5581356 C0.000142379261,5.51605735 5.51591497,0.000284416036 12.5579932,0.000284416036 L109.034181,0.000284416036 C111.63189,0.000284416036 114.2296,1.10870731 116.161687,3.04150578 C118.093061,4.97359236 119.20006,7.57059009 119.20006,10.166164 L119.20006,106.642352 C119.20006,113.683718 113.683576,119.200202 106.642209,119.200202 L106.642209,119.200202 Z"
            id="Fill-1"
            fill="#464646"
          ></path>
          <mask id="mask-2-ItemView" fill="white">
            <use xlinkHref="#path-1-ItemView"></use>
          </mask>
          <g id="Clip-4"></g>
          <path
            d="M149.498225,105.24675 L240.791807,105.24675 L240.791807,13.9531676 L149.498225,13.9531676 L149.498225,105.24675 Z M242.187124,119.199918 L148.102908,119.199918 C141.06083,119.199918 135.545057,113.684145 135.545057,106.642067 L135.545057,12.5578509 C135.545057,5.51577259 141.06083,0 148.102908,0 L244.579095,0 C247.174669,0 249.771667,1.10771065 251.703754,3.04050913 C253.636552,4.97259571 254.744975,7.57030533 254.744975,10.1658793 L254.744975,106.642067 C254.744975,113.684145 249.229202,119.199918 242.187124,119.199918 L242.187124,119.199918 Z"
            id="Fill-3"
            fill="#464646"
            mask="url(#mask-2-ItemView)"
          ></path>
          <path
            d="M13.95331,236.805686 L105.246892,236.805686 L105.246892,145.511392 L13.95331,145.511392 L13.95331,236.805686 Z M106.642209,250.758142 L12.5579932,250.758142 C5.51591497,250.758142 0.000142379261,245.242369 0.000142379261,238.201003 L0.000142379261,144.116075 C0.000142379261,137.073997 5.51591497,131.558224 12.5579932,131.558224 L109.034181,131.558224 C111.631179,131.558224 114.228888,132.665935 116.160263,134.597309 C118.092349,136.529396 119.20006,139.127106 119.20006,141.724103 L119.20006,238.201003 C119.20006,245.242369 113.683576,250.758142 106.642209,250.758142 L106.642209,250.758142 Z"
            id="Fill-5"
            fill="#464646"
            mask="url(#mask-2-ItemView)"
          ></path>
          <path
            d="M149.498225,236.805188 L240.791807,236.805188 L240.791807,145.510893 L149.498225,145.510893 L149.498225,236.805188 Z M242.187124,250.758355 L148.102908,250.758355 C141.06083,250.758355 135.545057,245.242583 135.545057,238.200504 L135.545057,144.116288 C135.545057,137.07421 141.06083,131.558438 148.102908,131.558438 L244.579095,131.558438 C247.173957,131.558438 249.770955,132.665436 251.70233,134.596099 C253.63584,136.528186 254.744975,139.125895 254.744975,141.724317 L254.744975,238.200504 C254.744975,245.242583 249.229202,250.758355 242.187124,250.758355 L242.187124,250.758355 Z"
            id="Fill-6"
            fill="#464646"
            mask="url(#mask-2-ItemView)"
          ></path>
        </g>
      </g>
    </svg>
  );
};
